if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}


// KFFIT: make wrapped product gallery arrows select previous/next thumbnails.
(function () {
  function visibleThumbs(gallery) {
    return Array.from(gallery.querySelectorAll('.thumbnail-list__item .thumbnail, .thumbnail-list__item button')).filter(function (button) {
      return button.offsetParent !== null;
    });
  }

  function activeIndex(thumbs) {
    var index = thumbs.findIndex(function (button) {
      var item = button.closest('.thumbnail-list__item');
      return button.getAttribute('aria-current') === 'true' || (item && item.classList.contains('is-active'));
    });
    return index >= 0 ? index : 0;
  }

  function move(gallery, direction) {
    var thumbs = visibleThumbs(gallery);
    if (thumbs.length < 2) return;
    var next = activeIndex(thumbs) + direction;
    if (next < 0) next = thumbs.length - 1;
    if (next >= thumbs.length) next = 0;
    thumbs[next].click();
    thumbs[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function enable() {
    document.querySelectorAll('[id^=MediaGallery] .thumbnail-slider > .slider-button').forEach(function (button) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[id^=MediaGallery] .thumbnail-slider > .slider-button');
    if (!arrow) return;
    var gallery = arrow.closest('[id^=MediaGallery]');
    if (!gallery) return;
    event.preventDefault();
    event.stopPropagation();
    move(gallery, arrow.classList.contains('slider-button--prev') ? -1 : 1);
  }, true);

  document.addEventListener('DOMContentLoaded', enable);
  document.addEventListener('shopify:section:load', enable);
  window.addEventListener('load', enable);
  setTimeout(enable, 300);
  setTimeout(enable, 1000);
  enable();
})();


// KFFIT: disable automatic product-image hover zoom; keep click-to-open modal behavior.
(function () {
  function injectStyle() {
    if (document.getElementById('kffit-disable-hover-zoom')) return;
    var style = document.createElement('style');
    style.id = 'kffit-disable-hover-zoom';
    style.textContent = '[id^="MediaGallery"] .zoomImg{display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;}[id^="MediaGallery"] .product__media.zoom{cursor:default!important;}';
    document.head.appendChild(style);
  }

  function disableHoverZoom() {
    injectStyle();
    document.querySelectorAll('[id^="MediaGallery"] .product__media.zoom').forEach(function (media) {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.zoom) {
        try { window.jQuery(media).trigger('zoom.destroy'); } catch (error) {}
      }
      media.classList.remove('zoom');
      media.style.cursor = 'default';
    });
    document.querySelectorAll('[id^="MediaGallery"] .zoomImg').forEach(function (image) {
      image.style.display = 'none';
      image.style.opacity = '0';
      image.style.visibility = 'hidden';
      image.style.pointerEvents = 'none';
    });
  }

  document.addEventListener('DOMContentLoaded', disableHoverZoom);
  document.addEventListener('shopify:section:load', disableHoverZoom);
  window.addEventListener('load', disableHoverZoom);
  setTimeout(disableHoverZoom, 300);
  setTimeout(disableHoverZoom, 1000);
  disableHoverZoom();
})();


// KFFIT: add a visible click-to-open zoom button on product gallery images.
(function () {
  function injectZoomButtonStyle() {
    if (document.getElementById('kffit-gallery-zoom-button-style')) return;
    var style = document.createElement('style');
    style.id = 'kffit-gallery-zoom-button-style';
    style.textContent = [
      '[id^="MediaGallery"] .product__modal-opener{position:relative;}',
      '[id^="MediaGallery"] .kffit-gallery-zoom-button{position:absolute;right:18px;top:18px;width:44px;height:44px;border:0;border-radius:999px;background:#fff;color:#171917;display:flex;align-items:center;justify-content:center;z-index:6;box-shadow:0 10px 30px rgba(23,25,23,.18);cursor:pointer;transition:transform .18s ease,background .18s ease,color .18s ease,box-shadow .18s ease;}',
      '[id^="MediaGallery"] .kffit-gallery-zoom-button:hover{background:#171917;color:#fff;transform:translateY(-1px);box-shadow:0 14px 34px rgba(23,25,23,.25);}',
      '[id^="MediaGallery"] .kffit-gallery-zoom-button svg{width:19px;height:19px;display:block;}',
      '@media screen and (max-width:749px){[id^="MediaGallery"] .kffit-gallery-zoom-button{right:12px;top:12px;width:38px;height:38px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function openMedia(opener) {
    var nativeButton = opener.querySelector('.product__media-toggle');
    if (nativeButton) {
      nativeButton.click();
      return;
    }
    if (typeof opener.click === 'function') opener.click();
  }

  function addZoomButtons() {
    injectZoomButtonStyle();
    document.querySelectorAll('[id^="MediaGallery"] .product__modal-opener').forEach(function (opener) {
      if (opener.querySelector('.kffit-gallery-zoom-button')) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'kffit-gallery-zoom-button';
      button.setAttribute('aria-label', 'Open image zoom');
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10.5 18a7.5 7.5 0 1 1 5.3-2.2l4.2 4.2-1.4 1.4-4.2-4.2A7.46 7.46 0 0 1 10.5 18Zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm-1-8h2v2h2v2h-2v2h-2v-2h-2v-2h2V8Z" fill="currentColor"/></svg>';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openMedia(opener);
      });
      opener.appendChild(button);
    });
  }

  document.addEventListener('DOMContentLoaded', addZoomButtons);
  document.addEventListener('shopify:section:load', addZoomButtons);
  window.addEventListener('load', addZoomButtons);

// KFFIT: place the zoom button above the actual product image layer.
(function () {
  function injectMediaLayerZoomStyle() {
    if (document.getElementById('kffit-media-layer-zoom-style')) return;
    var style = document.createElement('style');
    style.id = 'kffit-media-layer-zoom-style';
    style.textContent = [
      '[id^="MediaGallery"] .product__media{position:relative!important;}',
      '[id^="MediaGallery"] .kffit-media-layer-zoom-button{position:absolute!important;right:16px!important;top:16px!important;min-width:72px!important;height:40px!important;padding:0 15px!important;border-radius:999px!important;background:#171917!important;color:#fff!important;border:2px solid #fff!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:12px!important;font-weight:700!important;letter-spacing:.08em!important;line-height:1!important;text-transform:uppercase!important;z-index:2147483647!important;opacity:1!important;visibility:visible!important;box-shadow:0 14px 34px rgba(0,0,0,.35)!important;pointer-events:auto!important;cursor:pointer!important;}',
      '[id^="MediaGallery"] .kffit-media-layer-zoom-button:hover{background:#302724!important;transform:translateY(-1px);}',
      '[id^="MediaGallery"] .kffit-gallery-zoom-button{display:none!important;}',
      '@media screen and (max-width:749px){[id^="MediaGallery"] .kffit-media-layer-zoom-button{right:12px!important;top:12px!important;min-width:62px!important;height:36px!important;font-size:11px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function openProductMedia(media) {
    var opener = media.closest('.product__modal-opener');
    var nativeButton = opener && opener.querySelector('.product__media-toggle');
    if (nativeButton) {
      nativeButton.click();
      return;
    }
    if (opener && typeof opener.click === 'function') opener.click();
  }

  function addMediaLayerZoomButtons() {
    injectMediaLayerZoomStyle();
    document.querySelectorAll('[id^="MediaGallery"] .product__media').forEach(function (media) {
      if (media.querySelector('.kffit-media-layer-zoom-button')) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'kffit-media-layer-zoom-button';
      button.setAttribute('aria-label', 'Open image zoom');
      button.appendChild(document.createTextNode('Zoom'));
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openProductMedia(media);
      });
      media.appendChild(button);
    });
  }

  document.addEventListener('DOMContentLoaded', addMediaLayerZoomButtons);
  document.addEventListener('shopify:section:load', addMediaLayerZoomButtons);
  window.addEventListener('load', addMediaLayerZoomButtons);
  setTimeout(addMediaLayerZoomButtons, 300);
  setTimeout(addMediaLayerZoomButtons, 1000);
  addMediaLayerZoomButtons();
})();

  setTimeout(addZoomButtons, 300);
  setTimeout(addZoomButtons, 1000);
  addZoomButtons();
})();


// KFFIT: keep the product zoom control as a compact corner button.
(function () {
  if (document.getElementById('kffit-compact-zoom-button-style')) return;
  var style = document.createElement('style');
  style.id = 'kffit-compact-zoom-button-style';
  style.textContent = '[id^="MediaGallery"] .product__media > .kffit-media-layer-zoom-button{left:auto!important;right:16px!important;top:16px!important;width:72px!important;min-width:72px!important;max-width:72px!important;height:40px!important;min-height:40px!important;padding:0!important;}@media screen and (max-width:749px){[id^="MediaGallery"] .product__media > .kffit-media-layer-zoom-button{right:12px!important;top:12px!important;width:62px!important;min-width:62px!important;max-width:62px!important;height:36px!important;}}';
  document.head.appendChild(style);
})();


// KFFIT: custom single-image zoom viewer for product gallery.
(function () {
  function injectSingleZoomStyle() {
    if (document.getElementById('kffit-single-zoom-viewer-style')) return;
    var style = document.createElement('style');
    style.id = 'kffit-single-zoom-viewer-style';
    style.textContent = [
      '.kffit-single-zoom-viewer{position:fixed;inset:0;background:rgba(23,25,23,.72);z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:28px;}',
      '.kffit-single-zoom-shell{position:relative;width:min(92vw,980px);height:min(88vh,920px);background:#f6f5f1;overflow:hidden;box-shadow:0 28px 80px rgba(0,0,0,.35);}',
      '.kffit-single-zoom-img{width:100%;height:100%;object-fit:contain;display:block;cursor:zoom-in;transform-origin:center center;transition:transform .18s ease;user-select:none;}',
      '.kffit-single-zoom-viewer.is-zoomed .kffit-single-zoom-img{cursor:grab;transition:none;}',
      '.kffit-single-zoom-viewer.is-dragging .kffit-single-zoom-img{cursor:grabbing;}',
      '.kffit-single-zoom-close{position:absolute;right:18px;top:18px;width:52px;height:52px;border-radius:999px;border:0;background:#fff;color:#171917;font-size:28px;line-height:1;display:flex;align-items:center;justify-content:center;box-shadow:0 12px 34px rgba(0,0,0,.2);cursor:pointer;z-index:3;}',
      '.kffit-single-zoom-help{position:absolute;left:18px;bottom:18px;background:#fff;color:#171917;padding:11px 16px;border-radius:999px;font-size:12px;font-weight:700;letter-spacing:.04em;z-index:3;}',
      '@media screen and (max-width:749px){.kffit-single-zoom-viewer{padding:12px}.kffit-single-zoom-shell{width:96vw;height:78vh}.kffit-single-zoom-close{width:44px;height:44px;font-size:24px}.kffit-single-zoom-help{font-size:11px;left:12px;bottom:12px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function currentMediaImage(button) {
    var media = button.closest('.product__media');
    var img = media && media.querySelector('img');
    if (!img) return null;
    return img;
  }

  function largeImageUrl(img) {
    return img.currentSrc || img.src || img.getAttribute('src') || '';
  }

  function openSingleZoomViewer(img) {
    injectSingleZoomStyle();
    var existing = document.querySelector('.kffit-single-zoom-viewer');
    if (existing) existing.remove();

    var viewer = document.createElement('div');
    viewer.className = 'kffit-single-zoom-viewer';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');

    var shell = document.createElement('div');
    shell.className = 'kffit-single-zoom-shell';

    var zoomImg = document.createElement('img');
    zoomImg.className = 'kffit-single-zoom-img';
    zoomImg.src = largeImageUrl(img);
    zoomImg.alt = img.alt || 'Product image';
    zoomImg.draggable = false;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'kffit-single-zoom-close';
    close.setAttribute('aria-label', 'Close image zoom');
    close.appendChild(document.createTextNode('×'));

    var help = document.createElement('div');
    help.className = 'kffit-single-zoom-help';
    help.appendChild(document.createTextNode('Click image to zoom'));

    var scale = 1;
    var panX = 0;
    var panY = 0;
    var startX = 0;
    var startY = 0;
    var dragging = false;

    function apply() {
      zoomImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
      viewer.classList.toggle('is-zoomed', scale > 1);
      help.textContent = scale > 1 ? 'Drag to inspect · click to reset' : 'Click image to zoom';
    }

    function reset() {
      scale = 1;
      panX = 0;
      panY = 0;
      apply();
    }

    zoomImg.addEventListener('click', function (event) {
      if (dragging) return;
      event.stopPropagation();
      if (scale > 1) {
        reset();
        return;
      }
      var rect = zoomImg.getBoundingClientRect();
      var x = event.clientX - rect.left - rect.width / 2;
      var y = event.clientY - rect.top - rect.height / 2;
      scale = 2.2;
      panX = -x * 1.05;
      panY = -y * 1.05;
      apply();
    });

    zoomImg.addEventListener('pointerdown', function (event) {
      if (scale <= 1) return;
      dragging = false;
      viewer.classList.add('is-dragging');
      zoomImg.setPointerCapture(event.pointerId);
      startX = event.clientX - panX;
      startY = event.clientY - panY;
    });

    zoomImg.addEventListener('pointermove', function (event) {
      if (scale <= 1 || !viewer.classList.contains('is-dragging')) return;
      dragging = true;
      panX = event.clientX - startX;
      panY = event.clientY - startY;
      apply();
    });

    zoomImg.addEventListener('pointerup', function () {
      viewer.classList.remove('is-dragging');
      setTimeout(function () { dragging = false; }, 0);
    });

    close.addEventListener('click', function () { viewer.remove(); });
    viewer.addEventListener('click', function (event) {
      if (event.target === viewer) viewer.remove();
    });
    document.addEventListener('keydown', function escapeZoom(event) {
      if (event.key === 'Escape' && document.body.contains(viewer)) {
        viewer.remove();
        document.removeEventListener('keydown', escapeZoom);
      }
    });

    shell.appendChild(zoomImg);
    shell.appendChild(close);
    shell.appendChild(help);
    viewer.appendChild(shell);
    document.body.appendChild(viewer);
    apply();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.kffit-media-layer-zoom-button');
    if (!button) return;
    var img = currentMediaImage(button);
    if (!img) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openSingleZoomViewer(img);
  }, true);
})();
